import { useI18n } from "../i18n/I18nContext";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { FeatureCard, CtaBlock } from "../components/Shared";

const TEA_IMG =
  "https://images.unsplash.com/photo-1765808693805-adcc532b36c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB0ZWElMjBjZXJlbW9ueSUyMGNoaW5hfGVufDB8fHx8MTc3NzM0NzY2NXww&ixlib=rb-4.1.0&q=85";

export default function Retreat() {
  const { t } = useI18n();
  return (
    <>
      <section className="relative overflow-hidden bg-midnight border-b border-white/5 pt-20">
        <div className="absolute inset-0">
          <img
            src={t.retreat.heroImage || TEA_IMG}
            alt=""
            className="w-full h-full object-cover opacity-35"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-midnight via-midnight/75 to-midnight/35" />
          <div className="absolute inset-0 bg-gradient-to-b from-midnight/35 via-transparent to-midnight" />
        </div>
        <div className="absolute inset-0 tech-grid-bg" />
        <div className="absolute -top-40 -right-32 w-[500px] h-[500px] rounded-full bg-coral/15 blur-3xl" />
        <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 pt-16 md:pt-24 pb-16 md:pb-20 grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-6">{t.retreat.overline}</div>
            <h1 className="font-display font-black tracking-tighter leading-[0.95] text-white text-5xl sm:text-6xl lg:text-7xl xl:text-8xl uppercase">
              {t.retreat.title}
            </h1>
            <p className="mt-8 max-w-xl text-white/65 text-lg md:text-xl font-display font-light leading-relaxed">
              {t.retreat.desc}
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#0E1117]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
          <Reveal>
            <div className="overline mb-6">PROGRAM · 项目</div>
            <h2 className="font-display font-extrabold tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05] max-w-3xl uppercase">
              Что входит в retreat-программу
            </h2>
          </Reveal>
          <Stagger className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
            {t.retreat.blocks.map((b, idx) => (
              <StaggerItem key={idx} className="bg-midnight-2">
                <FeatureCard title={b.t} desc={b.d} index={idx + 1} />
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <CtaBlock title={t.retreat.cta} buttonText={t.nav.cta} />
    </>
  );
}
